<div class="row p-2 mb-3 align-items-center">
  <div class="col-12 col-md-7 text-start">
    <div class="page-title-heading">
      <div class="page-title-icon"><i class="fa-solid fa-list-check"></i></div>
      <div>
        Composition par matière
        <div class="page-title-subheading">Compositions par matière</div>
      </div>
    </div>
  </div>
  <div class="col-12 col-md-5 text-end">
    <app-header></app-header>
  </div>
</div>

<div  class="card mb-3">
  <div class="card-body py-3">
    <div class="row g-3 align-items-end">
      <div class="col-12 col-md-4">
        <label for="" class="form-label mb-0">Choisir la classe</label>
        <ng-select  (change)="loadCourses($event)" >
            <ng-option selected disabled></ng-option>
            <ng-option *ngFor="let classroom of classrooms" [value]="classroom?.id">{{classroom?.name}}</ng-option>
        </ng-select>
      </div>
      <div class="col-12 col-md-4">
        <label for="" class="form-label mb-0">Choisir la matière</label>
        <ng-select  (change)="loadCompositions1($event)">
            <ng-option selected disabled></ng-option>
            <ng-option *ngFor="let c of courses" [value]="c?.id">{{c?.name}}</ng-option>
        </ng-select>
      </div>
      <div class="col-12 col-md-4">
        <label for="" class="form-label mb-0">Choisir la période</label>
        <ng-select  [(ngModel)]="periodId" name="periodId" (change)="loadCompositions2($event)">
            <ng-option selected disabled></ng-option>
            <ng-option *ngFor="let p of periods" [value]="p?.id">{{p?.name}}</ng-option>
        </ng-select>
      </div>
    </div>
  </div>
</div>
<div class="container">
    <div class="d-flex justify-content-center mb-3">
        <button *ngIf="is_published!=null && !is_published" (click)="setStatus(1)" type="button" class="btn btn-success btn-sm btn-label waves-effect waves-light me-3">
            Valider</button>
           <button  *ngIf="is_published!=null &&  is_published" (click)="setStatus(0)" type="button" class="btn btn-danger btn-sm btn-label waves-effect waves-light me-3">
            Désactiver</button>
           <button  (click)="show()" type="button" class="btn btn-primary btn-sm btn-label waves-effect waves-light me-3">
            Voir les notes de la composition </button>
    </div>
 <div class="card">
    <div class="card-body">
        <p>{{data!.length}} élément(s)</p>
        <div class="table-responsive">
        <table class="table table-sm table-bordered table-striped" >
            <thead class="">
                <tr>
                    <th style="width: 10px;">#</th>
                    <th>Libellé</th>
                    <th>Statut</th>
                </tr>
            </thead>
            <tbody>
                <tr (click)="checked(d)" [class.table-active]="selected_data?.id === d.id" style="cursor: pointer;" *ngFor="let d of compositions  | paginate: {
                itemsPerPage: pg.pageSize,
                currentPage: pg.p,
                totalItems: pg.total }">
                    <td>
                        <div class="form-check mb-2">
                            <input (click)="checked(d)" class="form-check-input" type="radio" [checked]="selected_data?.id === d.id" name="flexRadioDefault">
                        
                        </div>
                    </td>
                    <td>{{d.name}}</td>
                    <td>
                        <span *ngIf="d.is_published" class="badge bg-success">Validé</span>
                        <span *ngIf="!d.is_published" class="badge bg-danger">En attente de validation</span>

                    </td>
                </tr>
            
            </tbody>
        </table>
        </div>
        <pagination-controls 
      [maxSize]="9"
      [directionLinks]="true"
      [autoHide]="true"
      [responsive]="true"
      [previousLabel]="'Previous'"
      [nextLabel]="'Next'"
      [screenReaderPaginationLabel]="'Pagination'"
      [screenReaderPageLabel]="'page'"
      [screenReaderCurrentLabel]="'You\'re on page'">
     </pagination-controls>
    </div>
 </div>
</div>